// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__4_23X","filesListContainer":"PosDisputesFiles_filesListContainer__2jfTk","filesButton":"PosDisputesFiles_filesButton__2aH6C"};